import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetOverviewResponse } from './get-overview-response';
import { getOverviewResponseSchema } from './get-overview-response';

export async function getMonitoringOverviewApi(): Promise<
  IValidatedResponse<IGetOverviewResponse>
> {
  return getRequest<IGetOverviewResponse>({
    path: '/sys/monitoring/overview',
    schema: getOverviewResponseSchema,
  });
}
